var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "col-12 d-flex align-items-center justify-content-end new-user-header"
        },
        [
          _c(
            "ul",
            {
              staticClass: "list-disable-header desktop-main-menu",
              class: [
                _vm.isDrawerOpen ? "active" : "",
                (_vm.user.account === "user" && _vm.isMobile) || _vm.isIpad
                  ? "p-user-sec-mobile"
                  : ""
              ]
            },
            [
              _vm.isMobile || _vm.isIpad
                ? _c("li", { staticClass: "i-cre", attrs: { id: "i-cre" } }, [
                    _vm.companyName
                      ? _c("em", [_vm._v(_vm._s(_vm.companyName.charAt(0)))])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.companyName
                      ? _c("em", [
                          _vm._v(_vm._s(_vm.user.first_name.charAt(0)))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("strong", [_vm._v(_vm._s(_vm.user.first_name))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile || _vm.isIpad
                ? _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "home-link",
                          attrs: { to: { name: "impact" } },
                          nativeOn: {
                            click: function($event) {
                              return _vm.openMenuDrawer()
                            }
                          }
                        },
                        [_vm._v("HOME")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isDowngradeUser
                ? _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: { name: "giving-stories" } },
                          nativeOn: {
                            click: function($event) {
                              return _vm.openMenuDrawer()
                            }
                          }
                        },
                        [_vm._v("GIVING STORIES")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isDowngradeUser
                ? _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: { name: "view-all-projects" } },
                          nativeOn: {
                            click: function($event) {
                              return _vm.openMenuDrawer()
                            }
                          }
                        },
                        [_vm._v("PROJECTS")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.account === "company" &&
              !_vm.isMobile &&
              !_vm.isIpad &&
              _vm.totalGivingsammout > 0
                ? _c("li", [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Share")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "sub-menu" }, [
                      _vm.isHivePartner === 0
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "invite" } } },
                                [_vm._v("Refer a Friend")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isHivePartner === 1
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "hive-builder" } } },
                                [_vm._v("Refer a Friend")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "giving-widget" } } },
                            [_vm._v("Impact Widgets")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "campaign-settings" } } },
                            [_vm._v("Giving Campaign")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: { name: "gratitude-certificate" } }
                            },
                            [_vm._v("Gratitude Certificates")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "media-kit" } } },
                            [_vm._v("Media Kit")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.account === "company" &&
              !_vm.isMobile &&
              !_vm.isIpad &&
              _vm.totalGivingsammout === 0
                ? _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content:
                              _vm.totalGivingsammout > 0
                                ? ""
                                : "Create your first giving to unlock!",
                            class: "normal-tooltip"
                          },
                          expression:
                            "{ content: totalGivingsammout > 0 ? '' : 'Create your first giving to unlock!', class: 'normal-tooltip' }",
                          modifiers: { top: true }
                        }
                      ]
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "header-menu-disable",
                          attrs: { href: "#" }
                        },
                        [_vm._v("Share")]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "sub-menu",
                          staticStyle: { display: "none" }
                        },
                        [
                          _vm.isHivePartner === 0
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "invite" } } },
                                    [_vm._v("Refer a Friend")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isHivePartner === 1
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "hive-builder" } } },
                                    [_vm._v("Refer a Friend")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "giving-widget" } } },
                                [_vm._v("Impact Widgets")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: { name: "campaign-settings" } }
                                },
                                [_vm._v("Giving Campaign")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "gratitude-certificate" }
                                  }
                                },
                                [_vm._v("Gratitude Certificates")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "media-kit" } } },
                                [_vm._v("Media Kit")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.account === "company" &&
              !_vm.isMobile &&
              !_vm.isIpad &&
              _vm.totalGivingsammout > 0
                ? _c("li", [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Community")]),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.account === "company" &&
              !_vm.isMobile &&
              !_vm.isIpad &&
              _vm.totalGivingsammout === 0
                ? _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content:
                              _vm.totalGivingsammout > 0
                                ? ""
                                : "Create your first giving to unlock!",
                            class: "normal-tooltip"
                          },
                          expression:
                            "{ content: totalGivingsammout > 0 ? '' : 'Create your first giving to unlock!', class: 'normal-tooltip' }",
                          modifiers: { top: true }
                        }
                      ]
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "header-menu-disable",
                          attrs: { href: "#" }
                        },
                        [_vm._v("Community")]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile || (_vm.isIpad && !_vm.isDowngradeUser)
                ? _c("span", [
                    _vm.user.user_business.company_id !== null &&
                    _vm.user.account !== "company" &&
                    parseInt(_vm.user.user_business.is_admin)
                      ? _c(
                          "a",
                          {
                            staticClass: "pointer",
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.companyAccount()
                              }
                            }
                          },
                          [_vm._v("SWITCH TO COMPANY ACCOUNT")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user.user_business.company_id !== null &&
                    _vm.user.account === "company"
                      ? _c(
                          "a",
                          {
                            staticClass: "pointer",
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.personalAccount()
                              }
                            }
                          },
                          [_vm._v("SWITCH TO PERSONAL ACCOUNT")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile || (_vm.isIpad && _vm.isDowngradeUser)
                ? _c("span", [
                    _vm.user.user_business.company_id !== null &&
                    _vm.user.account === "company"
                      ? _c(
                          "a",
                          {
                            staticClass: "pointer",
                            attrs: { href: "javascript:void(0)" }
                          },
                          [_vm._v("Switch to Personal Account")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile || _vm.isIpad
                ? _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "white-btn",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [_vm._v("LOG OUT")]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.isDowngradeUser
            ? _c(
                "div",
                { staticClass: "noti" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "giving-cart" } } },
                    [
                      _c("aside", { staticClass: "cart" }, [
                        _c("div", [
                          _c("img", {
                            staticStyle: { opacity: "0.4" },
                            attrs: {
                              src:
                                "/static/front/images/menu-images/basket-icon.svg",
                              alt: ""
                            }
                          })
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            : _c("div", { staticClass: "noti" }, [
                _c(
                  "aside",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top",
                        value: {
                          content: _vm.isDowngradeUser
                            ? "Reactivate your membership to access this"
                            : "Favorite a Project first!",
                          class: "normal-tooltip"
                        },
                        expression:
                          "{ content: isDowngradeUser ? 'Reactivate your membership to access this' : 'Favorite a Project first!', class: 'normal-tooltip' }",
                        modifiers: { top: true }
                      }
                    ],
                    staticClass: "cart"
                  },
                  [
                    _c("img", {
                      staticStyle: { opacity: "0.4" },
                      attrs: {
                        src: "/static/front/images/menu-images/basket-icon.svg",
                        alt: ""
                      }
                    })
                  ]
                )
              ]),
          _vm._v(" "),
          _vm.user
            ? _c(
                "div",
                {
                  class:
                    _vm.user.account === "company"
                      ? "user-sec"
                      : "user-sec p-user-sec"
                },
                [
                  _vm.user.account === "company"
                    ? _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.companyName.charAt(0)))]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.companyName))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user.account !== "company"
                    ? _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.user.first_name.charAt(0)))
                        ]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.user.first_name))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isDowngradeUser
                    ? _c("div", [
                        _vm.user.account === "company"
                          ? _c("div", [
                              _c("p", [_vm._v("Business Account")]),
                              _vm._v(" "),
                              _c("ul", [
                                _vm.isAdminLogin
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.adminAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Back to Admin Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user.user_business.company_id
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.personalAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Switch to Personal Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user.user_business.company_id
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.personalAccountProfile()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Personal Profile & Settings"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("li", { staticClass: "menu-ti" }, [
                                  _vm._v("Company")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "business.company.profile"
                                          }
                                        }
                                      },
                                      [_vm._v("Company Profile")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "impact.history" }
                                        }
                                      },
                                      [_vm._v("Impact History")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "billing-details" }
                                        }
                                      },
                                      [_vm._v("Billing")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.logout()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/drop-down-icon/log-out.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("Log Out")
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.account !== "company"
                          ? _c("div", [
                              _c("p", [_vm._v("Personal Account")]),
                              _vm._v(" "),
                              _c("ul", [
                                _vm.isAdminLogin
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.adminAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Back to Admin Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user.user_business.company_id &&
                                parseInt(_vm.user.user_business.is_admin)
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.companyAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Switch To Company Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticStyle: {
                                      "border-bottom": "1px solid #ddd"
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "business.personal.profile"
                                          }
                                        }
                                      },
                                      [_vm._v("Personal Profile & Settings")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.logout()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/drop-down-icon/log-out.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("Log Out")
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDowngradeUser
                    ? _c("div", [
                        _vm.user.account === "company"
                          ? _c("div", [
                              _c("p", [_vm._v("Business Account")]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "menu-disable-list" }, [
                                _vm.isAdminLogin
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.adminAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Back to Admin Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user.user_business.company_id
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [_vm._v("Switch to Personal Account")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticStyle: {
                                      "border-bottom": "1px solid #ddd"
                                    }
                                  },
                                  [_vm._v("Company Profile & Settings")]
                                ),
                                _vm._v(" "),
                                _c("li", { staticClass: "menu-ti" }, [
                                  _vm._v("Company")
                                ]),
                                _vm._v(" "),
                                _c("li", [_vm._v("Company Profile")]),
                                _vm._v(" "),
                                _c("li", [_vm._v("Impact History")]),
                                _vm._v(" "),
                                _c("li", [_vm._v("Billing")]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.logout()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/drop-down-icon/log-out.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("Log Out")
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.account !== "company"
                          ? _c("div", [
                              _c("p", [_vm._v("Personal Account")]),
                              _vm._v(" "),
                              _c("ul", [
                                _vm.isAdminLogin
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd"
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pointer",
                                            on: {
                                              click: function($event) {
                                                return _vm.adminAccount()
                                              }
                                            }
                                          },
                                          [_vm._v("Back to Admin Account")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "no-a-tag",
                                    staticStyle: {
                                      "border-bottom": "1px solid #ddd"
                                    }
                                  },
                                  [_vm._v("Personal Profile & Settings")]
                                ),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.logout()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/drop-down-icon/log-out.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("Log Out")
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            : _c("div", { staticClass: "user-sec" }, [
                _c("span", [_vm._v("G")]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("Guest "),
                  _c(
                    "a",
                    {
                      staticStyle: { color: "white", "font-size": "18px" },
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-sign-out-alt" })]
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "overly-close",
        on: { click: _vm.toggleRightMenu }
      }),
      _vm._v(" "),
      _c("RouterLink", {
        staticClass: "overly-close",
        attrs: { to: "" },
        nativeOn: {
          click: function($event) {
            return _vm.closeMenu.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c("menuCustom", {
        attrs: {
          partner_level: _vm.partner_level,
          user: _vm.user,
          isHivePartner: _vm.isHivePartner,
          companyName: _vm.companyName
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sub-menu" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.b1g1.com/events/overview",
              target: "_blank"
            }
          },
          [_vm._v("Event Calendar")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          { attrs: { href: "https://blog.b1g1.com/", target: "_blank" } },
          [_vm._v("Blog & Stories")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "sub-menu", staticStyle: { display: "none" } },
      [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.b1g1.com/events/overview",
                target: "_blank"
              }
            },
            [_vm._v("Event Calendar")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://blog.b1g1.com/", target: "_blank" } },
            [_vm._v("Blog & Stories")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8441108", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8441108","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/HeaderDisable.vue
// module id = null
// module chunks = 